import { Grid } from "@mui/material";
import React from "react";
import WSTextField, { TextType } from "../../../../Components/TextBox/WSTextBox";
import { useFormContext } from "react-hook-form";
import WSSelectField from "../../../../Components/Select/WSSelect";
import config from "../../../../Config/clientConfig.json";
import WSPhone from "../../../../Components/Phone/WSPhone";
import { customValidation, validations } from "../../../../commonFunctions/CommonFunctions";

export const Address: React.FC<any> = React.memo((props) => {
  const { register, control } = useFormContext();
  return (
    <>
    <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSTextField
            control={control}
            id="addressOne"
            {...register("addressOne")}
            rules={{ required: true }}
            name="addressOne"
            label="Address line1 *"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            control={control}
            id="city"
            {...register("city")}
            rules={{ required: true }}
            name="city"
            label="City "
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            control={control}
            id="zip"
            {...register("zip")}
            rules={{ required: true }}
            name="zip"
            label="Zip"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSSelectField
            options={config.stateConfig.staticOptionData}
            rules={{ required: true }}
            {...register("selectstate")}
            id="select"
            control={control}
            defaultValue={"0"}
            label="State "
            name="selectstate"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSSelectField
            options={config.countryConfig.staticOptionData}
            rules={{ required: true }}
            {...register("country")}
            id="country"
            control={control}
            defaultValue={"0"}
            label="Country "
            name="country"
            labelType="Normal"

          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSPhone
            label={"Phone No"}
            id={"phone"}
            name={"phone"}
            control={control}
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            control={control}
            id="fax"
            {...register("fax")}
            rules={{ required: true }}
            name="fax"
            label="Fax"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
        <WSTextField
            control={control}
            id="email"
            {...register("email")}
            type={TextType.Text}
            rules={customValidation(true, validations.email)}
            name="email"
            label="Email"
            labelType="Normal"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <WSTextField
            control={control}
            id="website"
            {...register("website")}
            rules={{ required: true }}
            name="website"
            label="Website"
            labelType="Normal"
          />
        </Grid>
      </Grid>
      </>
      
  );
});
